const init = () => {
  const infoTabButtons = document.querySelectorAll('.js-infoTabButton');
  const infoTabContents = document.querySelectorAll('.js-infoTabContent');
  const infoTabContentWrapper = document.querySelector('.js-infoTabContentWrapper');

  const infoFlow = document.querySelector('.js-infoFlow');

  infoTabContentWrapper.style.height = infoTabContents[0].scrollHeight + 'px';

  infoTabButtons.forEach((button, index) => {
    const otherButtons = Array.from(infoTabButtons).filter((btn, btnIndex) => btnIndex !== index);
    const otherContents = Array.from(infoTabContents).filter((content, contentIndex) => contentIndex !== index);

    let contentHeight = infoTabContents[index].scrollHeight;

    button.addEventListener('click', () => {

      infoTabContentWrapper.style.height = contentHeight + 'px';

      otherButtons.forEach(btn => btn.classList.remove('is-active'));
      otherContents.forEach(content => content.classList.remove('is-active'));

      button.classList.add('is-active');
      infoTabContents[index].classList.add('is-active');

      // 1番目のタブが選択されたら選考フローを表示、そうでなければ非表示
      if (index === 0) {
        infoFlow.style.display = 'block';
      } else {
        infoFlow.style.display = 'none';
      }
    });
  });
}

const resize = () => {
  const activeContent = document.querySelector('.js-infoTabContent.is-active');
  const infoTabContentWrapper = document.querySelector('.js-infoTabContentWrapper');

  if (activeContent && infoTabContentWrapper) {
    infoTabContentWrapper.style.height = activeContent.scrollHeight + 'px';
  }
}

export {
  init,
  resize
}
